<template>
  <mdb-navbar position="top" expand="small" dark color="stylish" class="z-depth-1">
    <mdb-navbar-brand>
      {{ companyName }}
    </mdb-navbar-brand>
    <mdb-navbar-toggler>
<!--       <mdb-navbar-nav center> -->
<!--         <mdb-nav-item class="language-flag-item"><flag iso="us" class="language-flag" /></mdb-nav-item> -->
<!--         <mdb-nav-item class="language-flag-item"><flag iso="se" class="language-flag" /></mdb-nav-item> -->
<!--       </mdb-navbar-nav> -->
      <mdb-navbar-nav right>
        <mdb-nav-item :key="index" :id="index" v-for="(item, index) in navItems" class="nav-item" :class="{ 'active' : item.isVisible }" href="#" v-scroll-to="formatLink(item.name)">
          {{ item.name }}
        </mdb-nav-item>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem
} from 'mdbvue'

export default {
  name: 'SiteNav',
  props: {
    companyName: String,
    navItems: Array,
    activeItemId: Number
  },
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem
  },
  methods: {
    formatLink: (section) => {
      return '#' + section;
    }
  }
}
</script>

<style scoped>
.language-flag-item {
  font-size:16px;
}

.language-flag {
  border-radius: 10em;
}

.nav-item {
  border-radius: 10em;
}
</style>